import { render } from "./TanaoroshiConfirmDialog.vue?vue&type=template&id=8b21d844"
import script from "./TanaoroshiConfirmDialog.vue?vue&type=script&lang=js"
export * from "./TanaoroshiConfirmDialog.vue?vue&type=script&lang=js"

import "./TanaoroshiConfirmDialog.vue?vue&type=style&index=0&id=8b21d844&lang=css"

import exportComponent from "/codebuild/output/src413274616/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__